/* Skapad av Claude Code — Godispaket-picker (Köp fler & spara), design v7.
   Interceptar köpknappen när paketet är >1 påse: alla rader läggs via
   /cart/add.js med line item-property _godispaket, som Paket-motorn i
   svd-functions rabatterar enligt trappan. 1 påse = native köpflöde. */
(function () {
  'use strict';

  var PROPERTY_KEY = '_godispaket';

  function fmtMoneyKr(cents) {
    // Shopify-priser är i ören. Visa avrundat till hela kronor (rent).
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return Math.round(cents / 100).toString() + ' kr';
  }

  // ============== Cart drawer-appen UpCart (samma mönster som svd-addons) ==============
  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }
  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart auto-öppnar normalt själv */ }
  }

  // ============== Temats cart drawer (Vision 2024) ==============
  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];
  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') {
      new window.CartDrawer();
    }
  }
  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;
    renderDrawerSections(response);
    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  // ============== Picker Controller ==============
  function initPicker(root) {
    if (root.getAttribute('data-gp-init') === '1') return;
    root.setAttribute('data-gp-init', '1');

    var mainRow = root.querySelector('[data-gp-main]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gp-row]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-gp-tiers] .svd-gp__tier'));
    var moreBtn = root.querySelector('[data-gp-more]');
    var moreRows = root.querySelector('[data-gp-more-rows]');
    if (!mainRow || rows.length === 0) return;

    var moreCount = moreRows ? moreRows.querySelectorAll('[data-gp-row]').length : 0;
    // Huvudradens startantal (2 som default i markupen — kunden ser rabatten direkt)
    var mainDefaultQty = parseInt(mainRow.querySelector('[data-gp-qty]').textContent, 10) || 1;

    function rowQty(row) {
      return parseInt(row.querySelector('[data-gp-qty]').textContent, 10) || 1;
    }
    function setRowQty(row, qty) {
      row.querySelector('[data-gp-qty]').textContent = String(qty);
    }
    function checkedRows() {
      return rows.filter(function (row) { return row.classList.contains('is-checked'); });
    }
    function totalBags() {
      return checkedRows().reduce(function (sum, row) { return sum + rowQty(row); }, rowQty(mainRow));
    }

    function renderTiers() {
      var bags = totalBags();
      var activeMin = 0;
      var activePct = 0;
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        var reached = bags >= min;
        tier.classList.toggle('is-reached', reached);
        if (reached && min > activeMin) {
          activeMin = min;
          activePct = parseInt(tier.getAttribute('data-pct'), 10) || 0;
        }
      });
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        tier.classList.toggle('is-active', activeMin > 0 && min === activeMin);
      });
      renderAtcPrice(activePct);
    }

    // Paketpris på köpknappen — rabatterat + överstruket ordinarie (som Magbalans-pickern)
    var atcNow = root.querySelector('[data-gp-atc-now]');
    var atcWas = root.querySelector('[data-gp-atc-was]');
    var atcPrices = root.querySelector('[data-gp-atc-prices]');
    function rowPrice(row) {
      return parseInt(row.getAttribute('data-price'), 10) || 0;
    }
    function renderAtcPrice(pct) {
      if (!atcNow || !atcPrices) return;
      var total = rowPrice(mainRow) * rowQty(mainRow);
      checkedRows().forEach(function (row) { total += rowPrice(row) * rowQty(row); });
      if (!total) { atcPrices.hidden = true; return; }
      var discounted = Math.round(total * (100 - pct) / 100);
      atcNow.textContent = fmtMoneyKr(discounted);
      if (atcWas) {
        if (pct > 0) {
          atcWas.textContent = fmtMoneyKr(total);
          atcWas.hidden = false;
        } else {
          atcWas.hidden = true;
        }
      }
      atcPrices.hidden = false;
    }

    // Klick i pickern: stepper eller rad-toggle
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-gp-step]');
      if (step) {
        var row = step.closest('[data-gp-row], [data-gp-main]');
        var isMain = row.hasAttribute('data-gp-main');
        var min = isMain ? 1 : 0;
        var qty = Math.max(min, rowQty(row) + parseInt(step.getAttribute('data-gp-step'), 10));
        if (qty === 0) {
          row.classList.remove('is-checked');
          row.setAttribute('aria-checked', 'false');
          setRowQty(row, 1);
        } else {
          setRowQty(row, qty);
        }
        renderTiers();
        return;
      }
      var row = e.target.closest('[data-gp-row]');
      if (row) {
        toggleRow(row);
      }
    });

    // Tangentbord på raderna (role="checkbox")
    root.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var row = e.target.closest('[data-gp-row]');
      if (!row || e.target.closest('[data-gp-step]')) return;
      e.preventDefault();
      toggleRow(row);
    });

    function toggleRow(row) {
      var checked = row.classList.toggle('is-checked');
      row.setAttribute('aria-checked', checked ? 'true' : 'false');
      if (checked) setRowQty(row, 1);
      renderTiers();
    }

    // Visa fler / färre (texterna kommer från blockets inställningar)
    if (moreBtn && moreRows) {
      var labelMore = moreBtn.getAttribute('data-label-more') || 'Visa fler godisar';
      var labelLess = moreBtn.getAttribute('data-label-less') || 'Visa färre';
      moreBtn.addEventListener('click', function () {
        var open = moreRows.classList.toggle('is-open');
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        moreBtn.textContent = open ? '− ' + labelLess : '+ ' + labelMore + ' (' + moreCount + ')';
      });
    }

    // ============== Submit-intercept ==============
    // Interceptar köp av HUVUDPRODUKTEN (vilket formulär som helst vars
    // variant-id tillhör produkten — vanliga knappen och sticky-knappen).
    // Andra produkters formulär (quick add, rekommendationer) rörs aldrig.
    var ownVariantIds = (root.getAttribute('data-product-variants') || '')
      .split(',')
      .filter(Boolean);

    function formVariantId(form) {
      var idInput = form.querySelector('[name="id"]');
      return idInput ? String(idInput.value).trim() : '';
    }
    function isMainProductForm(form) {
      if (!form || form.getAttribute('action') === null) return false;
      if (form.getAttribute('action').indexOf('/cart/add') === -1) return false;
      return ownVariantIds.indexOf(formVariantId(form)) !== -1;
    }

    var processing = false;

    // Aktuellt variant-id för huvudprodukten: läs från produktformuläret på
    // sidan (följer variantväljaren), annars blockets data-attribut.
    function resolveMainVariantId() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var value = formVariantId(forms[i]);
        if (ownVariantIds.indexOf(value) !== -1) return parseInt(value, 10);
      }
      return parseInt(root.getAttribute('data-main-variant'), 10);
    }

    function packageItems(mainVariantId) {
      if (isNaN(mainVariantId)) return null;
      // _godispaket sätts bara när det faktiskt är ett paket (>1 enhet) —
      // ett ensamt köp via blockets knapp beter sig exakt som native.
      var isPackage = totalBags() > 1;
      var properties = null;
      if (isPackage) {
        properties = {};
        properties[PROPERTY_KEY] = '1';
      }
      function item(id, qty) {
        return properties ? { id: id, quantity: qty, properties: properties } : { id: id, quantity: qty };
      }
      var items = [item(mainVariantId, rowQty(mainRow))];
      checkedRows().forEach(function (row) {
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        if (isNaN(variantId)) return;
        items.push(item(variantId, rowQty(row)));
      });
      return items;
    }

    function addPackage(mainVariantId, triggerBtn) {
      if (processing) return;
      processing = true;
      if (triggerBtn) triggerBtn.classList.add('is-loading');
      var items = packageItems(mainVariantId);
      if (!items) {
        processing = false;
        if (triggerBtn) triggerBtn.classList.remove('is-loading');
        return;
      }
      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: wantedSections,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e && e.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          // Nollställ valen — paketet ligger i vagnen nu
          checkedRows().forEach(function (row) {
            row.classList.remove('is-checked');
            row.setAttribute('aria-checked', 'false');
            setRowQty(row, 1);
          });
          setRowQty(mainRow, mainDefaultQty);
          renderTiers();
          if (hasUpCart()) {
            renderDrawerSections(response);
            tryOpenUpCart();
          } else {
            openThemeCartDrawer(response);
          }
        })
        .catch(function (err) { console.warn('[svd-godispaket] add-to-cart misslyckades', err); })
        .finally(function () {
          processing = false;
          if (triggerBtn) triggerBtn.classList.remove('is-loading');
        });
    }

    // Blockets egen köpknapp — lägger huvudprodukten (+ ev. valda tillägg).
    var atcBtn = root.querySelector('[data-gp-atc]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        addPackage(resolveMainVariantId(), atcBtn);
      });
    }

    function shouldIntercept() {
      return totalBags() > 1;
    }

    // Capture-fas på document — hinner före temats product-form-element.
    document.addEventListener('click', function (e) {
      if (!shouldIntercept()) return;
      var button = e.target.closest('.single-add-to-cart-button, button[name="add"]');
      if (!button) return;
      var form = button.closest('form') || button.form;
      if (!isMainProductForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPackage(parseInt(formVariantId(form), 10));
    }, true);

    // Fallback om temat submittar formuläret på annan väg än knapp-klick.
    document.addEventListener('submit', function (e) {
      if (!shouldIntercept()) return;
      if (!isMainProductForm(e.target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPackage(parseInt(formVariantId(e.target), 10));
    }, true);

    renderTiers();
  }

  function mountAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-svd-godispaket]')).forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:block:select', mountAll);
})();
